export default ((props)=>props.theme);
export const id = (props)=>props.theme.id;

//# sourceMappingURL=theme.js.map